export default "__VITE_ASSET__897f0553__"